// src/popover/popover-context.ts
import { createContext } from "react";
var PopoverContext = createContext(
  void 0
);

export {
  PopoverContext
};
